import {Component, HostListener, Input, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {EmailService} from '../../../services/email.service';
import {Observable} from 'rxjs/Observable';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'choose-corporation-modal',
    templateUrl: './choose-corporation-modal.component.html',
    styleUrls: ['./choose-corporation-modal.component.scss']
})
export class ChooseCorporationModalComponent implements OnInit {
    @ViewChild('form') form;
    @Input() inviteTemplate = '';
    showModal = false;
    disabledSubmit = false;
    selectedCorporations = [];

    static parseTime(dateString: string): string {
        return (new DatePipe('en-US')).transform(dateString, 'hh:mm a');
    }

    constructor(
        public api: ApiClientService,
        public es: EmailService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.es.isChooseCorporationModalShow = false;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.es.isChooseCorporationModalShow = false;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if(this.selectedCorporations.length < 1) {
            toastr.warning('At least one coraporation must be chosen to proceed');
            return;
        }

        const data = {
            inviteTemplate : this.inviteTemplate
        };
        this.disabledSubmit = true;
        let observables = [];
        this.selectedCorporations.forEach(corporation => {
            const url = `/v1/corporation_number/${corporation.id}`;
            observables.push(this.api.patch('domainBD', url, data));
        });
        Observable.forkJoin(observables).subscribe(
            () => {
                toastr.success('Invitation message has been updated for chosen corporations.');
                this.disabledSubmit = false;
                $('#saveAsDefaultInvitation')[0].checked = false;
                this.hideModal();
            }, error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Failed to update Invitation message for some of the chosen corporations!');
            }
        );
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/email/choose-corporation-modal/choose-corporation-modal.component.ts